import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";

const footerLinks = [
  { label: "Sobre nós", href: "/sobre" },
  // { label: "Segurança", href: "/security" },
];

export const PublicFooter = () => (
  <Box
    component="footer"
    sx={{
      py: 2,
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      gap: 3,
    }}
  >
    {footerLinks.map(link => (
      <Link
        key={link.label}
        href={link.href}
        underline="hover"
        color="text.secondary"
        variant="body2"
      >
        {link.label}
      </Link>
    ))}
  </Box>
);
